// frontend/src/lib/supabaseClient.ts
//
// Frontend'in tek Supabase bağlantı noktası. Yalnızca "anon public" anahtarı
// kullanılır — bu anahtar tarayıcıda görünmesi güvenli olacak şekilde
// tasarlanmıştır (RLS politikaları gerçek korumayı sağlar).

import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Supabase ortam değişkenleri eksik. .env dosyasında VITE_SUPABASE_URL ve VITE_SUPABASE_ANON_KEY tanımlı olmalı.'
  );
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
